export default __webpack_public_path__ + "59a4aebdf5345b6fa7c3660fce72b999.png";